









import "./assets/fonts/iconfont.js";

import { Vue, Component, Watch } from 'vue-property-decorator';

import { browserVersion } from "@goodluck/util";

@Component({
    name: "App"
})
export default class App extends Vue {
    private includePage = [

    ].join(",");

    private mobileMode = false;

    created() {
        this.mobileMode = browserVersion().mobile;
        if(this.mobileMode) {
            this.$global.init();
        } else {
            document.documentElement.style.fontSize = "24px";
            document.body.style.display = "flex";
            document.body.style.alignItems = "center";
            document.body.style.justifyContent = "center";
        }
        this.setConsoleDebugVariable();
    }

    @Watch("$route.path")
    setConsoleDebugVariable() {
        setTimeout(() => {
            (window as any)["vv"] = (this as any).$router.currentRoute.matched[0]?.instances.default;
        }, 100);
    }
}
